export type TagType = 'LEMBRETE' | 'COBRANCA' | 'REVISTORIA' | 'REATIVACAO' | 'MARKETING' | 'PAGAMENTO' | 'ANIVERSARIO' | 'BOAS_VINDAS' | 'RENOVACAO';

export interface Tag {
  id: number;
  client_id: number;
  tag_name: string;
  tag_code: string;
  tag_display_name: string;
  tag_category: string;
  is_active: boolean;
  description?: string;
  created_at: string;
  updated_at: string;
  // Campos para compatibilidade com frontend
  name: string;
  type: TagType;
}

export interface NewTag {
  name: string;
  type: TagType;
  days_before_due?: number;
  days_after_due?: number;
  days_after_due_from?: number;
  days_after_due_to?: number;
  is_active?: boolean;
  description?: string;
}

export interface TagFormData {
  name: string;
  type: TagType;
  days_before_due: string;
  days_after_due: string;
  days_after_due_from?: string;
  days_after_due_to?: string;
  is_active: boolean;
  description: string;
}

export interface TagStats {
  type: TagType;
  count: number;
  active_count: number;
}

export const TAG_TYPES: { value: TagType; label: string; description: string }[] = [
  {
    value: 'LEMBRETE',
    label: 'Lembrete',
    description: 'Envio de lembretes antes do vencimento'
  },
  {
    value: 'COBRANCA',
    label: 'Cobrança',
    description: 'Envio de cobranças após o vencimento'
  },
  {
    value: 'REVISTORIA',
    label: 'Revistoria',
    description: 'Para importação de veículos que precisam de revistoria'
  },
  {
    value: 'REATIVACAO',
    label: 'Reativação',
    description: 'Para importação de boletos de reativação'
  },
  {
    value: 'MARKETING',
    label: 'Marketing',
    description: 'Para importação de veículos com campanhas de marketing'
  },
  {
    value: 'PAGAMENTO',
    label: 'Pagamento',
    description: 'Confirmação de pagamento / recibo'
  },
  {
    value: 'ANIVERSARIO',
    label: 'Aniversário',
    description: 'Mensagens de parabéns aos aniversariantes'
  },
  {
    value: 'BOAS_VINDAS',
    label: 'Boas-Vindas',
    description: 'Mensagens de boas-vindas a novos associados'
  },
  {
    value: 'RENOVACAO',
    label: 'Renovação',
    description: 'Mensagens de renovação (régua Hinova por código de situação)'
  }
];

export const getTagTypeDescription = (type: TagType): string => {
  const tagType = TAG_TYPES.find(t => t.value === type);
  return tagType?.label || type;
};

export const canHaveDaysConfig = (type: TagType): boolean => {
  return type === 'LEMBRETE' || type === 'COBRANCA' || type === 'REVISTORIA';
};
